/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Select_All_LabelInputs */

const en_context_menu_select_all_label = /** @type {(inputs: Context_Menu_Select_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select All`)
};

const fr_context_menu_select_all_label = /** @type {(inputs: Context_Menu_Select_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout selectionner`)
};

const de_context_menu_select_all_label = /** @type {(inputs: Context_Menu_Select_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle auswählen`)
};

const it_context_menu_select_all_label = /** @type {(inputs: Context_Menu_Select_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona tutto`)
};

const ru_context_menu_select_all_label = /** @type {(inputs: Context_Menu_Select_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбрать все`)
};

const es_context_menu_select_all_label = /** @type {(inputs: Context_Menu_Select_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar todo`)
};

const zh_cn2_context_menu_select_all_label = /** @type {(inputs: Context_Menu_Select_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全选`)
};

const ja_context_menu_select_all_label = /** @type {(inputs: Context_Menu_Select_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて選択`)
};

const hi_context_menu_select_all_label = /** @type {(inputs: Context_Menu_Select_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सबका चयन करें`)
};

const pt_pt2_context_menu_select_all_label = /** @type {(inputs: Context_Menu_Select_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar tudo`)
};

/**
* | output |
* | --- |
* | "Select All" |
*
* @param {Context_Menu_Select_All_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_select_all_label = /** @type {((inputs?: Context_Menu_Select_All_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Select_All_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_select_all_label(inputs)
	if (locale === "de") return de_context_menu_select_all_label(inputs)
	if (locale === "it") return it_context_menu_select_all_label(inputs)
	if (locale === "ru") return ru_context_menu_select_all_label(inputs)
	if (locale === "es") return es_context_menu_select_all_label(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_select_all_label(inputs)
	if (locale === "ja") return ja_context_menu_select_all_label(inputs)
	if (locale === "hi") return hi_context_menu_select_all_label(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_select_all_label(inputs)
	return en_context_menu_select_all_label(inputs)
});